export function getReadableTextClass(backgroundHex?: string): string {
  // default (no brand color)
  if (!backgroundHex) {
    return 'text-white'
  }

  // remove leading '#'
  const hex = backgroundHex.replace('#', '')

  // guard: invalid hex length
  if (hex.length !== 6) {
    return 'text-white'
  }

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  // YIQ contrast formula
  const yiq = (r * 299 + g * 587 + b * 114) / 1000

  return yiq >= 160 ? 'text-argus-forest-800' : 'text-white'
}
